import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {BaseView} from "../../view/base.view";
import {Subscription} from "rxjs";
import {tap} from "rxjs/operators";
import {EntityCollectionFindOneByAttributeService} from "../../service/entityCollectionFindOneByAttributeService";
import {AbstractFindOneByAttributeService} from "../../service/v2/service/findone/abstractFindOneByAttribute.service";
import {AbstractFindOneEntityByAttributeNoCacheService} from "../../service/v2/service/findone/abstractFindOneEntityByAttributeNoCacheService";

@Component({
    selector: 'app-view-by-attribute',
    templateUrl: './view-by-attribute.component.html',
})
export class ViewByAttributeComponent<Model> extends BaseView
    implements OnInit, OnDestroy, OnChanges, AfterViewInit {

    @Input() loadingText = 'Chargement en cours';
    @Input() value: any;
    @Input() findByAttributeService: EntityCollectionFindOneByAttributeService<Model, any> |
        AbstractFindOneByAttributeService<any, Model> | AbstractFindOneEntityByAttributeNoCacheService<Model, any>;
    @Input() ignoreNotFoundError = false;
    @Input() hideLoading = false;
    @Output() entityLoaded = new EventEmitter<Model>();
    subscriptions: Subscription[] = [];
    loading = false;
    error;
    notFound = false;
    entity: Model;

    constructor() {
        super();
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.findByAttributeService.loading$.subscribe(loading => this.loading = loading));

        this.subscriptions.push(this.findByAttributeService.entity$.pipe(
            tap(entity => {
                // console.log(['entity', entity]);
                this.entity = entity;
                if (entity) {
                    this.entityLoaded.emit(entity);
                }
            })).subscribe());

        this.loadEntity();
    }


    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const idChanges = changes['value'];
        if (idChanges && !idChanges.isFirstChange()) {
            if (this.value) {
                this.loadEntity();
            }
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(value => value?.unsubscribe());
    }

    private loadEntity() {
        this.findByAttributeService.loadEntity(this.value)
            .then((entity) => {
            if (!entity) {
                this.notFound = true;
                if (this.ignoreNotFoundError === true) {
                    this.entityLoaded.emit(undefined);
                }
            }
             })
            .catch((e) => {
                // console.log(e);
                this.error = e;
            });
    }


}
